import React from 'react';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../../Environment';
import * as R from 'ramda';

const ReferencesResultQuery = graphql`
query ReferencesResultQuery($contractId: ID!, $offerType: OfferTypeEnum!) {
  checkContractReferences(contractId: $contractId, offerType: $offerType)
}
`;

const ReferencesResult = ({
  contractId,
  offerType
}) => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return <QueryRenderer
    environment={environment}
    query={ReferencesResultQuery}
    variables={{
      contractId,
      offerType
    }}
    render={({ error, props }) => {
      if (error) {
        return <div>{error.stack}</div>;
      } else if (!props) {
        return null;
      }

      const isOk = R.pathEq(['checkContractReferences'], true, props);

      const result = isOk ? 'OK' : 'KO';
      const style = { color: isOk ? 'green' : 'red' };

      return <div style={style}>Table de paramétrage {result}</div>;
    }}
  />;
};

export default ReferencesResult;
